import { Injectable } from '@angular/core';

import { filterSportsEmitLast } from '@frontend/sports/host-app/sports-product/feature/utils';
import { DialogSettings, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';

import { WalletItem } from './account-balance.models';
import { AccountBalanceService } from './account-balance.service';
import { WalletSelectorComponent } from './wallet-selector/wallet-selector.component';
import { WalletStoreService } from './wallet-store.service';

@Injectable({ providedIn: 'root' })
export class WalletSelectorDialogService {
    private areWalletsValid: boolean;
    private isWalletSelectorConfirmed: boolean;
    private openModalHandle: ModalRef | null = null;

    constructor(
        private accountBalanceService: AccountBalanceService,
        private modalDialogService: ModalDialogService,
        private walletStoreService: WalletStoreService,
    ) {
        this.accountBalanceService.availableWallets
            .pipe(filterSportsEmitLast())
            .subscribe((wallets: WalletItem[]) => this.updateWalletsForSelector(wallets));
        this.updateWalletSelectorIsConfirmed();
    }

    open(settings?: DialogSettings, inColumn?: boolean): void {
        if (!this.openModalHandle) {
            this.close();
            this.openModalHandle = this.modalDialogService.openDialog(WalletSelectorComponent, {
                data: { inColumn },
                settings,
            });
            this.openModalHandle.result.then(() => this.updateWalletSelectorIsConfirmed());
        }
    }

    close(): void {
        if (this.openModalHandle) {
            this.openModalHandle.close();
            this.openModalHandle = null;
        }
    }

    get showWalletSelector(): boolean {
        return !this.isWalletSelectorConfirmed && this.areWalletsValid;
    }

    private updateWalletSelectorIsConfirmed(): void {
        this.isWalletSelectorConfirmed = this.walletStoreService.walletSelectorIsShown;
    }

    private updateWalletsForSelector(wallets: WalletItem[]): void {
        this.areWalletsValid = wallets.length > 1 && !wallets.some((w) => w.amount === 0) && !this.walletStoreService.isPermanentWallet;
    }
}
